<template>
	<div :id="`filter-field-${filter.key}`" class="filter-field">
		<TreeViewControl
			v-if="filter.type === 'treeview'"
			:ref="setRef"
			:label="filter.label"
			:items="filter.items || []"
			:title-key="filter.titleKey || 'name'"
			:title-key-translate="filter.titleKeyTranslate || false"
			:multiple="filter.multiple || false"
			:required="filter.required || false"
			:branch-selection="filter.branchSelection || false"
			:select-all="filter.selectAll || false"
			:show-selected-count="filter.showSelectedCount || false"
			:expand-on-search="filter.expandOnSearch || false"
			:search-fields="filter.searchFields || ['title']"
			:items-registration="filter.itemsRegistration || 'render'"
			@change="onChange"
		/>
		<ToggleControl v-else-if="filter.type === 'toggle'" :ref="setRef" :label="filter.label" :required="filter.required || false" :pre-selected="filter.preSelected ?? false" @change="onChange" />
		<PeriodFilterControl v-else-if="filter.type === 'daterange'" :ref="setRef" :label="filter.label" :presets="filter.presets || []" :required="filter.required || false" :pre-selected="filter.preSelected ?? null" :min-date="filter.minDate" :max-date="filter.maxDate" @change="onChange" />
		<TokenListControl v-else-if="filter.type === 'tokenlist'" :ref="setRef" :label="filter.label" :hint="filter.hint" :icon="filter.icon" :required="filter.required || false" :pre-selected="filter.preSelected ?? null" @change="onChange" />
		<SelectControl v-else :ref="setRef" :label="filter.label" :items="filter.items || []" :title-key="filter.titleKey || 'name'" :title-key-translate="filter.titleKeyTranslate || false" :multiple="filter.multiple || false" :required="filter.required || false" :item-value="filter.itemValue || 'id'" :pre-selected="filter.preSelected ?? null" :sort-items="filter.sortItems !== false" :clearable="filter.clearable ?? null" :density="filter.density || 'compact'" @change="onChange" />
	</div>
</template>

<script setup>
import TreeViewControl from '@/components/controls/TreeViewControl.vue';
import SelectControl from '@/components/controls/SelectControl.vue';
import ToggleControl from '@/components/controls/ToggleControl.vue';
import TokenListControl from '@/components/controls/TokenListControl.vue';
import PeriodFilterControl from '@/components/controls/PeriodFilterControl.vue';

const props = defineProps({
	filter: { type: Object, required: true },
});
const emit = defineEmits(['ref', 'change']);

function setRef(el) {
	emit('ref', el);
}

function onChange(value) {
	emit('change', value);
}
</script>

<style scoped>
.filter-field {
	min-width: 0;
}
</style>
